import AccountCaseSummary from './AccountCaseSummary';

export default AccountCaseSummary;
